<script>
    export default {
        props: ['educator', 'educatorID', 'editable'],
        async mounted () {   
          var city_map = await this.$store.getters.getStatesToCities
          this.city_map = city_map

        },
        data() {
            return {
                editing: false,
                uploading: false,
                file: null,
                photoPath: "",
                photoURL: null,
                city_map: {},
                cities: [],
                location: {
                  state: "",
                  city: ""
                },
                gradeFlagHashArray: {},
                renderCitySelect: true
            }
        },
        filters: {
          capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
          }
        },   
        computed: {
          displayPhone: function() {
            var phone = this.educator.phone;
            try {
              phone = phone.replace(/[^\/\d]/g,'');
              var mod_phone = '('+phone.substring(0,3)+') '+phone.substring(3,6)+'-'+phone.substring(6,10);
              phone = mod_phone
            } catch (e) {
              console.log(e)
            }
            return phone
          },
          callPhone: function() {
            var phone = this.educator.phone;
            try {
              phone = phone.replace(/[^\/\d]/g,'');
            } catch (e) {
              console.log(e)
            }
            return phone
          }          
        }, 
        watch: {
          educatorID(newVal) {
            this.showPicture()
          }
        },
        methods: {  
          async showPicture() {
            // display image
            try {
              this.photoURL = await this.$store.getters.getEducatorPictureDownloadURL(this.educatorID)
            } catch (e) {
              console.log("Error showing educator photo: " + e)
            }
            
          },
          toggleGradeFlag( flag ){
            flag.active = !flag.active
          },    
          dismissUpload(){
            this.uploading = false
            this.educator = this.beforeEdit
          },    
          dismiss() {
            this.educator = this.beforeEdit

            if( this.educator.location ){
              this._location = this.educator.location
            }
            this.editing = false;
            this.uploading = false;
          },
          openModal() {
            if ( !this.editable ) { return }
            this.beforeEdit = JSON.parse(JSON.stringify(this.educator))
            console.log("openModal basic")        

            if ( !this.educator.location ) {
              this.educator.location = {}
              this.educator.location.city = ""
              this.educator.location.state = ""
            }
            this.editing = true
          },
          openUploadModal() {
            if ( !this.editable ) { return }
            this.beforeEdit = JSON.parse(JSON.stringify(this.educator))
            this.uploading = true
          },
          save() {
            if ( !this.editable ) { return }
            this.educator.profileUpdated = true
            console.log("emitting save")
            this.$emit('save')
            this.editing=false
          },
          filesChange(event) {
            if ( !this.editable ) { return }
            // handle file changes
            this.file = event.target.files[0]
          },          
          changeState(event) {
              console.log("state value: " + event.target.value);
              this.educator.location.state = event.target.value;
              this.educator.location.city = "";
              this.renderCitySelect = false
              this.$nextTick(() => {
                this.renderCitySelect = true
              });              
          },       
          async savePicture() {
            if ( !this.editable ) { return }
            var _this = this
            this.$store.dispatch('saveEducatorPhoto', { educatorID: this.educatorID, file: this.file} ).then(function (success) {
                console.log("photo saved")
                _this.showPicture()
              })
              .catch(function (err) {
                console.error('Error saving image to firebase', err);
              });
            this.uploading = false;

          }          
        }
        
    }
</script>



<template lang="pug">

.foo 
  #profile.z-depth-1
    .row.edit-div( v-if="editable")
        .col.s12.right-align
          img.edit-icon.modal-trigger(data-target='industry-info' src='@/assets/svg/bluepencil.svg' @click="openModal")
    .row
      //Edit photo div if user has no photo
      #no-picture.edit-div.col.s12.m12.l5.valign-wrapper(v-if="!photoURL && editable")
        .row
          .col.edit-div
            img.edit-icon#img-edit-icon.modal-trigger(
            data-target='industry-picture-modal' 
            src='@/assets/svg/blueplussign.svg'
            @click="openUploadModal")
            p#profile-text Add a profile picture
      #picture.col.s12.m12.l5(v-else)
        img#company-img.col.s12.edit-curr-img.modal-trigger(
          data-target='industry-picture-modal' 
          :src="photoURL" 
          @click="openUploadModal")

      .col.s12.m7.l7#no-personal-info.edit-div(v-if="!educator.profileUpdated && editable")
        img.edit-icon.modal-trigger(
          data-target='educ-info' 
          src='@/assets/svg/Asset14.svg'
          @click="openModal")
        span  Add your contact information and location!

      .col.s12.m7.l7#personal-info
        .row
          .col
            h6#name {{educator.fName}} {{educator.lName}}
            p#school {{educator.school}}
            p#gradeAffiliation Grade(s):
            .gradeContainer
              .gradeListLabel( v-for="(grade, index) in educator.gradeAffiliation" v-if="grade.active" )
                span.gradeLabel {{grade.gradeLabel | capitalize }}
        .row
          .col
            p( v-if="educator.location" )
              span#city {{educator.location.city}}, 
              span#state {{educator.location.state}}
            p#email
              a(:href="'mailto:' + educator.email" target="_blank") {{educator.email}}
            p#phone
              a(:href="'tel:' + callPhone" target="_blank") {{displayPhone}}

  #educ-info(v-if="editing")
    .modal-overlay2(@click="dismiss")
      .modal-content( @click.stop="" )
        .row
          .modal-hdr.col.s12.no-padding
            h6 Personal information
            hr           
        form#info-form
          #form-div
            .row
              .col.s10.offset-s1
                br
                p.form-label Your Name
                input#educName.input-div(type='text' placeholder="First Name" v-model="educator.fName")
                input#educName.input-div(type='text' placeholder="Last Name" v-model="educator.lName")                  
            .row
              .col.s10.offset-s1
                p.form-label Your Email
                input#educEmail.input-div(type='email' name="educEmail" placeholder="Your email here" v-model="educator.email")
            .row
              .col.s10.offset-s1
                p.form-label Contact Phone Number
                input#educPhone.input-div(type="text" name="educPhone" placeholder="Your phone here" v-model="educator.phone")
            .row
              .col.s10.offset-s1
                p.form-label School Name
                input#educSchool.input-div(type='text' name="educSchool" placeholder="Your school here" v-model="educator.school")
            .row
              .col.s10.offset-s1
                p.form-label School Location
            .row.location-input
              .col.s5.offset-s1
                select#company-state( v-model="educator.location.state" @change="changeState($event)" )
                  option(value='' disabled selected) Select State
                  option(v-for="(cityarray, state) in city_map" :value="state") {{state}}
              .col.s5
                select#company-city( v-model="educator.location.city" v-if="renderCitySelect")
                  option(value='' disabled selected) Select City
                  option(v-for="city in city_map[educator.location.state]" :value="city") {{city}}     
            .row
              .col.s10.offset-s1
                p.form-label Check the grade levels you currently teach:
                .grade-checkbox(v-for="gradeStruct in educator.gradeAffiliation")
                  label {{gradeStruct.gradeLabel | capitalize}}
                  input.grade-checkbox(type="checkbox"
                    true-value="yes"
                    false-value="no"
                    :checked="gradeStruct.active"
                    v-bind="gradeStruct"
                    @click="toggleGradeFlag(gradeStruct)"
                  )
        .row
          .col.s12.close-btn-div#educ_info_btn
            button.close-btn.modal-close#save-personal-info(type='button' @click="save") SAVE
          .col.s12.close-btn-div
            button.close-btn.modal-close(type='button' @click="dismiss") CANCEL



  #educ-picture-modal(v-if="uploading")
    .modal-overlay2(@click="dismiss")
      .modal-content( @click.stop="" )
        .row
          .col.s12.header-lgn
            h5.center-align Upload Photo
            hr
        .row
          .col.s12.center-align
            p
              | Upload a photo for people to see.
        .row
          .col.s12
            .input-field.file-field
              .btn
                span Photo
                input#educ-picture(type='file' @change="filesChange")
              .file-path-wrapper
                input.file-path.validate(type='text' v-model="photoPath")
          .row
            .col.s12.close-btn-div
              button.close-btn.modal-close#save-picture(type='button' @click="savePicture") SAVE
            .col.s12.close-btn-div
              button.close-btn.modal-close(type='button' @click="dismissUpload()") CANCEL


</template>



<style lang="sass" scoped>


// .btn
//   float: left;
//   height: 3rem;
//   line-height: 3rem;

// .btn, .btn-large 
//     text-decoration: none;
//     color: #fff;
//     background-color: #26a69a;
//     text-align: center;
//     letter-spacing: .5px;
//     transition: .2s ease-out;
//     cursor: pointer;  

.file-field input[type=file] 
    position: absolute !important
//     top: 0;
//     right: 0;
//     left: 0;
//     bottom: 0;
//     width: 100%;
//     margin: 0;
//     padding: 0;
//     font-size: 20px;
//     cursor: pointer;
//     opacity: 0;
    


#gradeAffiliation
  float: left 

.gradeContainer
  padding-top: 15px
  padding-bottom: 15px
  padding-left: 5px
  float: left

.gradeLabel
  border: thin solid gray
  border-radius: 5px
  padding: 2px 3px 2px 3px
  margin-right: 5px
  -webkit-box-shadow: -2px 2px 4px -2px rgba(0,0,0,0.75);
  -moz-box-shadow: -2px 2px 4px -2px rgba(0,0,0,0.75);
  box-shadow: -2px 2px 4px -2px rgba(0,0,0,0.75);

.gradeListLabel
  float: left

label
  color: black

.location-input
  padding-bottom: 20px

input
  opacity: 100 !important
  position: relative !important
  pointer-events: all !important

.grade-checkbox
  padding: 5px
  float: left
  font-size: 1.5em
  label
    padding-right: 5px;  


/*****************************************/
//company info block
/*****************************************/
  
#profile 
    margin-top: 2em;
    padding: .5em;
    background-color: #fff;  

#no-company-info 
  margin: 0;


#no-picture 
  background-color: #f1f1f1;
  margin: 0;
  text-align: center;


#no-picture .edit-div 
  margin-top: -40px;
  text-align: center;


.input-field 
  margin-top: 0 !important;


#img-edit-icon 
  margin-left: 40%;
  margin: 0;
  width: 50px;
  height: 50px;  
  
.edit-icon
  cursor: pointer



#no-picture 
  background-color: #D3D3D3;
  height: 200px;


#profile-text 
  font-size: 10px;


.no-padding 
    padding: 0;



#no-company-info span 
  font-size: 12px;
  color: #bbbbbb;


.edit-curr-img:hover 
  cursor: pointer;
  cursor: hand;

// don't think this is needed
// #company-info .edit-icon 
//     margin-left: 15px !important;


// #company-info .col 
//   padding: 0 !important;



.close-btn 
  border: 1px solid #000;
  color: #000;
  padding: .75em 4em .75em 4em;


.close-btn-div 
  margin: 0 0 .75em 0;
  text-align: center;

.close-btn:hover 
  border-color: #33404f;
  background-color: #33404f;
  color: #fff;


.margin-top-hr 
  margin-bottom: 0;


#opportunities .template-row 
  padding-bottom: 0;


.opp-icon 
  padding-top: .5em;
  font-size: 32px;

select
  display:block !important
  border: thin solid black

input
    background-color: transparent;
    border: none;
    border-bottom: 1px solid #9e9e9e;
    border-radius: 0;
    outline: none;
    height: 3rem;
    width: 100%;
    font-size: 1rem;
    margin: 0 0 20px 0 !important
    padding: 0;
    box-shadow: none;
    box-sizing: content-box;
    transition: all 0.3s;


.opp.row .col 
  padding: 0;
</style>